import {LayoutActions, LayoutTypes} from "./index";
import {SnackbarActions, SnackBarMessageType} from "../snackbar";
import { all, apply, put, takeLatest } from 'redux-saga/effects'
import monitoringService from "../../services/monitoring.service";

export function* monitoringDatabases() {
    const { changeDatabaseStatusFailure, changeDatabaseStatusSuccess } = LayoutActions
    const { openSnackBar } = SnackbarActions
    try {
        const monitoringStatus = yield apply(monitoringService, monitoringService.getDataBaseStatus, [])
        yield put(changeDatabaseStatusSuccess({ monitoringStatus }))
    } catch (err: any) {
        yield put(changeDatabaseStatusFailure())
        yield put(openSnackBar({ type: SnackBarMessageType.ERROR, title: 'Erro.', message: 'Ocorreu um erro ao verificar o status dos bancos de dados.' }))
    }
}

export function* statesStatus() {
    const { changeStateStatusFailure, changeStateStatusSuccess } = LayoutActions
    const { openSnackBar } = SnackbarActions
    try {
        const stateStatus = yield apply(monitoringService, monitoringService.geStatesStatus, [])
        yield put(changeStateStatusSuccess({ stateStatus }))
    } catch (err: any) {
        yield put(changeStateStatusFailure())
        yield put(openSnackBar({ type: SnackBarMessageType.ERROR, title: 'Erro.', message: 'Ocorreu um erro ao verificar o status dos estados.' }))
    }
}

const monitoringSaga = function* () {
    yield all([
        takeLatest(LayoutTypes.DATABASE_STATUS, monitoringDatabases),
        takeLatest(LayoutTypes.STATES_API_STATUS, statesStatus),
    ])
}

export default monitoringSaga
